import React, { useEffect } from 'react';
import { useForm, XBox } from '@orderx/lab/ui';

interface Props {
    areaCode: string;
    phone: string;
    onChange({ areaCode, phone }: { areaCode: string; phone: string }): void;
}

export function XInputPhone({ areaCode, phone, onChange }: Props) {
    const formPhone = useForm<{
        phone: string;
    }>({
        phone: {
            type: 'phone',
            placeholder: 'Enter phone',
            value: {
                areaCode,
                phone,
            },
        },
    });

    const { areaCode: _areaCode, phone: _phone } = formPhone.getData().phone as any;

    useEffect(() => {
        onChange({
            areaCode: _areaCode,
            phone: _phone,
        });
    }, [_areaCode, _phone]);

    return <XBox fullWidth>{formPhone.getInputElement('phone')}</XBox>;
}
